// extracted by mini-css-extract-plugin
export default {"wrap":"vacations_wrap__eQzAG","vacations__panel":"vacations_vacations__panel__4y5Hp"};